export default "__VITE_PUBLIC_ASSET__a2d250d2__"